import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Input } from '@playcastdotio/Shadcn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import { faEnvelopes } from '@fortawesome/pro-solid-svg-icons';
import config from '../../config.json';
import { isIOS } from '../../utility/utility';

export const Ios = () => {
  const [invite, setInvite] = useState<string>('');
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const persistentIdFromUrl = searchParams.get('id');

  const handleJoin = () => {
    const inviteCode = invite.split('/').pop();
    const url = `/j/${inviteCode}${persistentIdFromUrl ? `?id=${persistentIdFromUrl}` : ''}`;
    navigate(url);
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setInvite(text);
    } catch (err) {
      console.error('Failed to read clipboard contents: ', err);
    }
  };

  const handleMailTo = () => {
    window.location.href = 'mailto:support@playcast.io';
  };

  return (
    <div className='bg-hero bg-content text-content-text m-0 h-auto w-full bg-cover bg-no-repeat p-0'>
      <div className='container mx-auto h-dvh w-full px-8 py-10'>
        <section id='hero' className='grid grid-cols-12 gap-x-4 gap-y-8'>
          <div className='col-span-full flex flex-grow flex-row items-center justify-center gap-x-2 pt-3 align-middle'>
            <img src='/images/playcast_logo-96x96.png' alt='Logo' className='h-12 w-12' />
            <h1 className='text-content-text-headline font-headline text-3xl font-bold md:pt-2'>
              <Link to='/'>Playcast</Link>
            </h1>
          </div>

          {/* @ts-expect-error: Property 'standalone' does not exist on type 'Navigator' */}
          {!window.navigator.standalone ? (
            <div className='grid-rows bg-footer col-span-10 col-start-2 mx-auto mt-8 grid justify-items-center gap-y-4 rounded-lg p-6 shadow-md lg:col-span-8 lg:col-start-3'>
              <h3 className='row-auto text-center text-2xl font-bold'>
                {isIOS() ? 'Add to Home Screen' : "You don't appear to be using IOS."}
              </h3>
              <p className='row-auto text-center'>
                {isIOS() ? "From safari's share menu" : 'You wont need this page. simply click a join link and have fun!'}
              </p>
              {isIOS() && (
                <span className='mt-2 flex gap-x-1'>
                  Tap{' '}
                  <svg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'>
                    <path d='M0 0h24v24H0V0z' fill='none' />
                    <path
                      fill='white'
                      d='M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2z'
                    />
                  </svg>
                  then "Add to home screen"{' '}
                </span>
              )}
            </div>
          ) : (
            <div className='grid-rows col-span-full mx-auto grid content-center justify-center gap-y-2 text-center lg:gap-y-8'>
              <p className='row-auto mx-auto my-0 text-lg italic'>Paste your session invite link here</p>
              {/* <h2 className='row-auto -mt-4 font-bold text-2xl lg:text-3xl'>{invitationState.currentState.selectedInvite?.description}</h2> */}
              {/* {hostConnectionState.currentState.status === 'disconnected' && <>Host disconnected. Please try again later.</>} */}
              <div className='row-auto w-full gap-2'>
                <Input
                  value={invite}
                  onChange={(e) => setInvite(e.target.value)}
                  type='text'
                  id='inviteCode'
                  name='inviteCode'
                  required
                  placeholder='Invite link'
                  className='bg-content mb-2 h-auto w-full rounded border-none px-4 py-3 text-center text-lg shadow-sm'
                />
                <Button type='button' className='rounded-full' onClick={handleJoin}>
                  Connect to Playcast
                </Button>
              </div>
              <div className='mt-16 flex flex-col gap-y-4 rounded-lg bg-gray-800 p-6'>
                <h3 className='row-auto text-center text-xl font-semibold'>Need Support?</h3>
                <p>Join the discord, submit a bug ticket, or email us directly at support@playcast.io</p>
              </div>
              <div className='m-4 flex items-center justify-center gap-x-8'>
                <Link to={config.DISCORD_URL}>
                  <div className='flex w-fit items-center rounded-lg bg-gray-700 p-1'>
                    <FontAwesomeIcon icon={faDiscord} className='h-8 w-8 text-yellow-400' />
                  </div>
                </Link>
                <Button size='icon' className='bg-gray-700 hover:bg-gray-700 focus:bg-gray-700 active:bg-gray-700' onClick={handleMailTo}>
                  <FontAwesomeIcon icon={faEnvelopes} className='h-8 w-8 text-yellow-400' />
                </Button>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};
